import BaseModel from './BaseModel'
import {currentDate, currentConseillerId} from '@/helpers'

export default class ContactModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      ID_PROSPECT: null,
      ID_CONTACT: null,
      ID_CONSEILLER: currentConseillerId(),
      CODE_REF_TYPE_ECHANGE: null,
      COMPTE_RENDU: '',
      PROCHAINES_ETAPES: ''
    }
    super(data, relation, fields)
  }
}
